import { getCanonicalOrigin, SITE_NAME } from "@/config/site";

/** Schéma Product pour une fiche dossier publique. */
export function buildDossierProductJsonLd(dossier, dossierId) {
  const origin = getCanonicalOrigin();
  const url = `${origin}/dossier/${dossierId}`;
  const name = dossier?.title || dossier?.titre || "Annonce RdvMarket";
  const description = String(dossier?.description || name).slice(0, 500);
  const isRecherche = String(dossier?.type || "").toLowerCase() === "recherche";
  const price =
    !isRecherche && dossier?.price != null && dossier.price !== ""
      ? Number(dossier.price)
      : null;

  const offer =
    price != null && Number.isFinite(price)
      ? {
          "@type": "Offer",
          price: String(price),
          priceCurrency: "EUR",
          availability: "https://schema.org/InStock",
          url,
        }
      : undefined;

  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name,
    description,
    url,
    brand: { "@type": "Brand", name: SITE_NAME },
    ...(offer ? { offers: offer } : {}),
  };
}

/** ItemList pour la marketplace (aperçu des annonces visibles). */
export function buildMarketplaceItemListJsonLd(dossiers, limit = 20) {
  const origin = getCanonicalOrigin();
  const items = (dossiers || []).slice(0, limit).map((d, i) => {
    const id = d.dossier_id || d.id;
    return {
      "@type": "ListItem",
      position: i + 1,
      url: `${origin}/dossier/${id}`,
      name: d.title || d.titre || `Annonce ${i + 1}`,
    };
  });
  if (!items.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: items,
  };
}
